import { Component, Vue, Prop as prop } from 'nuxt-property-decorator';
import { showFlash } from '~/lib/flash';

@Component({
    components: {
        loader: require('~/components/common/loader-block').default,
        btn: require('~/components/form/button').default,
    },
})
export default class ReviewsReplyComponent extends Vue {

    @prop()
    public id: number;

    @prop()
    public value;
    private loading = false;
    private message = '';

    public close() {
        this.$emit('input', false);
    }

    public async send() {

        if (!this.message.length) {
            return;
        }

        try {

            this.loading = true;

            await this.$store.dispatch('RestRequest', {
                url: '/catalog/reviews/add-comment',
                params: {
                    review_id: this.id,
                    message: this.message,
                }
            });

            showFlash({
                text: 'Комментарий будет добавлен после проверки модератором',
                type: 'success',
                timeout: 3000,
            });

            this.close();

        } catch {
            showFlash({
                text: 'Ошибка добавления отзыва',
                type: 'error',
                timeout: 3000,
            });
        } finally {
            this.loading = false;
        }
    }
}
